import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  employeeToken: attr(String),
  firstName: attr(String),
  lastName: attr(String),
  readOnlyFullName: attr(String)
});